"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToModalProps({ data, mappers, packages, forms }) {
    let modal = null;
    if (!('blockType' in data)) {
        modal = data;
    }
    else if (data.modalReference && typeof data.modalReference === 'object') {
        modal = data.modalReference;
    }
    return {
        heading: modal?.heading,
        noExit: modal?.noExit,
        children: modal?.mainContent &&
            mappers.mapRichText({ richText: modal?.mainContent, mappers, packages, forms }),
        modalText: modal?.modalTrigger &&
            mappers.mapRichText({ richText: modal?.modalTrigger, mappers, packages, forms }),
    };
}
exports.default = mapToModalProps;
